import React, { Component, Fragment, useEffect, useState } from "react"
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Alert,
  Input,
  Row,
  Col,
  Table,
  CustomInput,
} from "reactstrap"
import LaddaButton, { EXPAND_RIGHT } from "react-ladda"
import { FormattedNumber } from "../../FormattedNumber/FormattedNumber"
import { NumberFormatInput } from "../../NumberFormatInput/NumberFormatInput"
import classnames from "classnames"
import { OrderStatus, OrderAction, CommonsHelper, getBaseAndPriceCurrencies } from "../../../utils"
import { OrderPriceType } from "../../../utils/Order/Order"
import CircularProgress from "../../CircularProgress/CircularProgress"
import OrderInlineDetail from "../../Order/InlineDetail"
import { Field, Combobox, Switch } from "../Order/Field/Field"
import { showToast } from "../../../utils/Helper"
import { CouponPayments } from "../../Asset/Tabs/Contracts/Contracts"
import ItemRow from "./ItemRow"
import style from "./Cross.module.scss"
import { setLoading } from "../../Quotebar/_state"
import { useDebounce } from "../../../utils/hooks"
import { TradingRoutes } from "../Trading/FormFields"
const { localDateToGMT } = CommonsHelper

const Cross = ({ onToggle, open, order, orders, services }) => {
  const [accounts, setAccounts] = useState(null)
  const [items, setItems] = useState({
    a1: { enabled: false, error_account: "" },
  })
  const [confirm, setConfirm] = useState({
    enabled: false,
    loading: false,
  })
  const [totals, setTotals] = useState({
    crossingQuantity: null,
    crossingAverage: null,
    buySide: null,
    sellSide: null,
    Fees: undefined,
  })
  const [fx, setFx] = useState(1)
  const [manualFX, setManualFX] = useState(false)
  const [valueDate, setValueDate] = useState(new Date().toDatetimeLocal())
  const [type, setType] = useState("Internal")
  const [date, setDate] = useState(new Date().toDatetimeLocal())
  const [error, setError] = useState(null)
  const [settlementCurrencies, setSettlementCurrencies] = useState([])
  const [maxDecimals, setMaxDecimals] = useState(4)
  const [parValue, setParValue] = useState(1)
  const [contractdata, setContractdata] = useState(false)
  const [closingLeg, setClosingLeg] = useState(0)
  const [allowSelection, setAllowSelection] = useState(true)
  const [calculatingLegs, setCalculatingLegs] = useState(false)
  const [errors, setErrors] = useState({})
  const [showFees, setShowFees] = useState(false)
  const [sideStr, setSideStr] = useState()
  const [accountsSelected, setAccountsSelected] = useState([])
  const [isFX, setIsFX] = useState(false)
  const [baseCurrency, setBaseCurrency] = useState()
  const [priceCurrency, setPriceCurrency] = useState()
  const [hasDifferentCurrencies, setHasDifferentCurrencies] = useState()
  const [loadingItem, setLoadingItem] = useState({})
  const debItems = useDebounce(items, 300)
  const [itemsFees, setItemsFees] = useState({})
  const [first, setFirst] = useState(true)
  const [tradingRoutes, setTradingRoutes] = useState([])
  const [tradingRouteSelected, setTradingRouteSelected] = useState({})
  const [tradersNames, setTradersNames] = useState([])
  const [selectedTrader, setSelectedTrader] = useState()
  const [showTraderName, setshowTraderName] = useState(true)
  const [paymentToBorrower, setPaymentToBorrower] = useState (false)

  const handleSelectedTrader = (name) => {
    setSelectedTrader(name)
  }

  useEffect(() => {
    if (order) {
      order.OrderSide.toLowerCase()
      setTotals((prev) => ({
        ...prev,
        [`${sideStr}Side`]: +order.stats.pending,
      }))

      setIsFX(order.AssetClassForm == "Forex")

      const newHasDifferentCurrencies =
        order.OrderCurrencySymbol !== "" &&
        order.OrderSettlementCurrencySymbol != "" &&
        order.OrderCurrencySymbol != order.OrderSettlementCurrencySymbol

      setHasDifferentCurrencies(newHasDifferentCurrencies)
    }
  }, [order])

  useEffect(() => {
    if (order) {
      const currencies = getBaseAndPriceCurrencies(
        settlementCurrencies,
        order.OrderCurrencySymbol,
        order.OrderSettlementCurrencySymbol
      )

      setBaseCurrency(currencies.baseCurrency)
      setPriceCurrency(currencies.priceCurrency)
    }
  }, [order, settlementCurrencies])

  useEffect(() => {
    if (orders) {
      const newFilteredOrders = filterOrders(orders).length > 0 || (items["a1"] && items["a1"].enabled)
      setAccountsSelected(() => newFilteredOrders)
    }
  }, [orders, items])

  useEffect(() => {
    if (tradingRouteSelected.TradingRouteId) {
      getRepoDefaultPaymentToBorrower(tradingRouteSelected.TradingRouteId);
    }
  }, [tradingRouteSelected])

  useEffect(() => {
    getTradingRoutes()
    const trader_name_input =
      window.___APP_CONFIG___ && window.___APP_CONFIG___.TRADER_NAME_INPUT
        ? window.___APP_CONFIG___.TRADER_NAME_INPUT
        : false
    setshowTraderName((prevState) => ({ ...prevState, showTraderName: trader_name_input }))

    if (trader_name_input) {
      getAuthorizedTraders()
    }
  }, [])

  useEffect(() => {
    const newTotals = calcTotals(debItems)
    services
      .fetchGetCalculator({
        assetId: order.AssetId,
        isSecurity: true,
        quantity: newTotals.crossingQuantity || 1,
        price: newTotals.crossingAverage || 1,
        date: date,
      })
      .then((res2) => {
        const ExecutionTotal2 = res2.calculator.total
        const payload = {
          crossType: "",
          execution: {
            ExecutionQuantity: newTotals.crossingQuantity || 0,
            ExecutionPrice: contractdata.marketValue || 0,
            ExecutionValueDate: valueDate,
            ExecutionTotal: ExecutionTotal2,
            SettlementCurrencyId: order.OrderSettlementCurrencyId,
            TradingRouteId: tradingRouteSelected.TradingRouteId,
          },
        }

        if (order.AssetClassForm === "Repo" && contractdata)
          payload.execution.contractdata = { ...contractdata, closing: closingLeg }
        services
          .getExecutionFees(payload)
          .then(({ response }) => {
            newTotals.Fees = response.execution.Fees
            newTotals.ExecutionTotal = ExecutionTotal2
            setTotals(() => newTotals)
            setError(() => undefined)
          })
          .catch((err) => {
            console.error(err)
            showToast("Error fetching fees")
          })
      })
      .catch((err) => {
        console.error(err)
        showToast("Error fetching fees")
      })

    const promises = Object.entries(debItems).map((entry) => {
      const [name, value] = entry

      return services
        .fetchGetCalculator({
          assetId: order.AssetId,
          isSecurity: true,
          quantity: value.quantity || 1,
          price: value.price || 1,
          date: date,
        })
        .then((res) => {
          const ExecutionTotal = res.calculator.total
          const payload = {
            crossType: "",
            execution: {
              ExecutionQuantity: value.quantity || 0,
              ExecutionPrice: value.price || 0,
              ExecutionValueDate: date,
              ExecutionTotal: ExecutionTotal,
              SettlementCurrencyId: order.OrderSettlementCurrencyId,
              TradingRouteId: tradingRouteSelected.TradingRouteId,
            },
          }

          if (order.AssetClassForm === "Repo" && contractdata)
            payload.execution.contractdata = { ...contractdata, closing: closingLeg }
          return services
            .getExecutionFees(payload)
            .then(({ response }) => {
              value.Fees = response.execution.Fees
              value.ExecutionTotal = ExecutionTotal

              return {
                name,
                value,
              }
            })
            .catch((err) => {
              console.error(err)
              showToast("Error fetching fees")
            })
        })
        .catch((err) => {
          console.error(err)
          showToast("Error fetching fees")
        })
    })

    Promise.all(promises).then((itemFee) => {
      setItemsFees((prev) => ({
        ...prev,
        [itemFee[0].name]: {
          Fees: itemFee[0].value.Fees,
          ExecutionTotal: itemFee[0].value.ExecutionTotal,
        },
      }))
    })
  }, [debItems])

  useEffect(() => {
    getAccounts()
    getSettlementCurrencies(true, true)
  }, [])

  useEffect(() => {
    Object.keys(items).forEach((key) => {
      const currentItem = items[key]
      if (currentItem.enabled) {
        services
          .fetchGetCalculator({
            assetId: order.AssetId,
            isSecurity: true,
            quantity: currentItem.quantity || 1,
            price: currentItem.price || 1,
            date: date,
          })
          .then((res) => {
            const ExecutionTotal = res.calculator.total
            const payload = {
              crossType: "",
              execution: {
                ExecutionQuantity: currentItem.quantity || 0,
                ExecutionPrice: currentItem.price || 0,
                ExecutionValueDate: date,
                ExecutionTotal: ExecutionTotal,
                SettlementCurrencyId: order.OrderSettlementCurrencyId,
                TradingRouteId: tradingRouteSelected.TradingRouteId,
              },
            }

            if (order.AssetClassForm === "Repo" && contractdata)
              payload.execution.contractdata = { ...contractdata, closing: closingLeg }

            services
              .getExecutionFees(payload)
              .then(({ response }) => {
                currentItem.Fees = response.execution.Fees
                currentItem.ExecutionTotal = ExecutionTotal

                setItems((prev) => ({
                  ...prev,
                  [key]: currentItem,
                }))
              })
              .catch((err) => {
                console.error(err)
                showToast("Error fetching fees")
              })
          })
          .catch((err) => {
            console.error(err)
            showToast("Error fetching fees")
          })
      }
    })
  }, [date, type, order, tradingRouteSelected])

  useEffect(() => {
    getSettlementCurrencies(true, !manualFX)
  }, [manualFX])

  useEffect(() => {
    if (order.AssetClassForm === "Repo") {
      handleGetLegs()
    }
  }, [
    contractdata.price,
    contractdata.appraisal,
    contractdata.quantity,
    contractdata.marketValue,
    contractdata.CollateralQuantity,
    contractdata.maturity,
    contractdata.rate,
    contractdata.paymenttoborrower,
    allowSelection,
  ])

  useEffect(() => {
    if (order.AssetClassForm === "Repo") {
      if (contractdata && !calculatingLegs) {
        const newTotals = calcTotals(debItems)
        services
          .fetchGetCalculator({
            assetId: order.AssetId,
            isSecurity: true,
            quantity: newTotals.crossingQuantity || 1,
            price: newTotals.crossingAverage || 1,
            date: date,
          })
          .then((res) => {
            const ExecutionTotal2 = res.calculator.total
            const payload = {
              crossType: "",
              execution: {
                ExecutionQuantity: newTotals.crossingQuantity || 0,
                ExecutionPrice: contractdata.marketValue || 0,
                ExecutionValueDate: valueDate,
                ExecutionTotal: ExecutionTotal2,
                SettlementCurrencyId: order.OrderSettlementCurrencyId,
                TradingRouteId: tradingRouteSelected.TradingRouteId,
              },
            }

            if (order.AssetClassForm === "Repo" && contractdata)
              payload.execution.contractdata = { ...contractdata, closing: closingLeg }
            services
              .getExecutionFees(payload)
              .then(({ response }) => {
                newTotals.Fees = response.execution.Fees
                newTotals.ExecutionTotal = ExecutionTotal2
                setTotals(() => newTotals)
                setError(() => undefined)
              })
              .catch((err) => {
                console.error(err)
                showToast("Error fetching fees")
              })
          })
          .catch((err) => {
            console.error(err)
            showToast("Error fetching fees")
          })
      }
    }
  }, [contractdata, closingLeg])

  useEffect(() => {
    if (order.AssetClassForm === "Repo") {
      if (contractdata && !calculatingLegs) {
        const newTotals = calcTotals(debItems)
        services
          .fetchGetCalculator({
            assetId: order.AssetId,
            isSecurity: true,
            quantity: newTotals.crossingQuantity || 1,
            price: newTotals.crossingAverage || 1,
            date: date,
          })
          .then((res) => {
            const ExecutionTotal2 = res.calculator.total
            const payload = {
              crossType: "",
              execution: {
                ExecutionQuantity: newTotals.crossingQuantity || 0,
                ExecutionPrice: newTotals.crossingAverage || 0,
                ExecutionValueDate: date,
                ExecutionTotal: ExecutionTotal2,
                SettlementCurrencyId: order.OrderSettlementCurrencyId,
                TradingRouteId: tradingRouteSelected.TradingRouteId,
              },
            }

            if (order.AssetClassForm === "Repo" && contractdata)
              payload.execution.contractdata = { ...contractdata, closing: closingLeg }
            services
              .getExecutionFees(payload)
              .then(({ response }) => {
                newTotals.Fees = response.execution.Fees
                newTotals.ExecutionTotal = ExecutionTotal2
                setTotals(() => newTotals)
                setError(() => undefined)
              })
              .catch((err) => {
                console.error(err)
                showToast("Error fetching fees")
              })
          })
          .catch((err) => {
            console.error(err)
            showToast("Error fetching fees")
          })
      }
    }
  }, [contractdata, closingLeg])

  const getAuthorizedTraders = () => {
    const { getAuthorizedTraders } = services
    if (getAuthorizedTraders) {
      getAuthorizedTraders().then((r) => {
        if (r.response) {
          setTradersNames(r.response.authUsers)
        }
      })
    }
  }

  const getRepoDefaultPaymentToBorrower = (id) => {
    if (services.getRepoDefaultPaymentsCorrespondent) {
      services.getRepoDefaultPaymentsCorrespondent(id).then(({ response }) => {
        const data = response ? response.execution : null;
        const paymentToBorrower = data && data.contractdata ? data.contractdata.paymenttoborrower : 0;
        setPaymentToBorrower(paymentToBorrower)
        if (contractdata)
          handleChangeContractData("paymenttoborrower", paymentToBorrower)
      });
    }
  };

  const getAccounts = () => {
    const { fetchSearchAccount } = services

    fetchSearchAccount({ text: "", length: 99 }).then((res) => {
      const newAccounts = res.response.accounts.map((a) => ({
        id: a.Id,
        description: JSON.parse(a.Value).value,
      }))
      setAccounts(() => newAccounts)
    })
  }

  const getTradingRoutes = () => {
    const { OrderId } = order
    const { fetchTradingRoutes } = services

    fetchTradingRoutes({ processId: OrderId, quantity: order.OrderQuantity })
      .then((res) => ({
        routes: res.response.sorroutes,
        logs: res.response.keyvalues,
      }))
      .then(({ routes, logs }) => {
        //remove duplicates
        let uniqueRoutes = []

        let preferredRouteId = -1
        let betterPreference = 9999

        routes.forEach((r) => {
          if (r.name != "") {
            if (uniqueRoutes.find((e) => e.id == r.id) == undefined) {
              uniqueRoutes.push(r)
              if (r.preference < betterPreference) {
                preferredRouteId = r.id
                betterPreference = r.preference
              }
            }
          }
        })

        if (uniqueRoutes.find((e) => e.id == tradingRouteSelected.TradingRouteId) == undefined) {
          setTradingRouteSelected({ TradingRouteId: preferredRouteId })
        }

        setTradingRoutes(
          uniqueRoutes.map((r) => ({
            id: r.id,
            description: r.name,
          }))
        )
      })
  }

  const getSettlementCurrencies = (updateValueDate, updateFX) => {
    const { fetchOrderAssetInfo } = services

    const data = {
      tradeDate: date,
      orderForm: order.AssetClassForm,
      assetId: order.AssetId,
      assetTicker: order.AssetTicker,
      tradeCurrencyId: order.OrderCurrencyId,
      settleCurrencyId: order.OrderSettlementCurrencyId,
    }

    fetchOrderAssetInfo(data).then((res) => {
      const { settlementCurrency, items } = res.response.assetorderdata

      if (settlementCurrency && updateFX) {
        const settleCurrency = settlementCurrency.find(
          (c) => c.currencyInfo.currencyId == order.OrderSettlementCurrencyId
        )

        setSettlementCurrencies(() => settlementCurrency)
        setFx(() => parseFloat(settleCurrency.fx))
      }

      if (updateValueDate && items.find((i) => i.key == "SettlementDayDate")) {
        setValueDate(() => items.find((i) => i.key == "SettlementDayDate").value)
      }

      if (items.find((i) => i.key == "MaxDecimals")) {
        setMaxDecimals(parseInt(items.find((i) => i.key == "MaxDecimals").value, 10))
      }

      if (items.find((i) => i.key == "ParValue")) {
        setParValue(() => parseFloat(items.find((i) => i.key == "ParValue").value))
      }
    })
  }

  const toggleItem = (itemId) => {
    setLoadingItem((prev) => ({ ...prev, [itemId]: true }))
    const _item = items[itemId]

    let item = _item || { enabled: false }

    // suma todas las quantity enabled
    const promiseSumQty = new Promise((resolveQty) => {
      if (!item.enabled) {
        const { fetchChangeOrderStatus } = services

        let promiseAck = Promise.resolve()

        if (itemId != "a1") {
          if (orders[itemId].OrderStatus === OrderStatus.ROUTED) {
            item.loading = true

            setItems((prev) => ({
              ...prev,
              [itemId]: {
                ...item,
              },
            }))

            promiseAck = new Promise((resolve) => {
              fetchChangeOrderStatus({ action: OrderAction.ACK, itemId, form: order.AssetClassForm }).then(
                (res) => resolve(res)
              )
            })
          }
        }

        promiseAck.then((ackRes) => {
          const sumQty = Object.entries(items).reduce((sum, entry) => {
            const [name, v] = entry

            if (v.enabled && name !== itemId) {
              return sum + (v.quantity != "" ? parseFloat(v.quantity) : 0)
            }

            return sum
          }, 0)

          if (itemId != "a1") {
            item.quantity = Math.min(orders[itemId].stats.pending, Math.max(order.stats.pending - sumQty, 0))
          } else {
            item.quantity = Math.max(order.stats.pending - sumQty, 0)
          }

          resolveQty()
        })
      } else {
        resolveQty()
      }
    })

    promiseSumQty.then((presult) => {
      services
        .fetchGetCalculator({
          assetId: order.AssetId,
          isSecurity: true,
          quantity: item.quantity || 1,
          price: item.price || 1,
          date: date,
        })
        .then((res) => {
          const ExecutionTotal = res.calculator.total

          const payload = {
            crossType: "",
            execution: {
              ExecutionQuantity: item.quantity || 0,
              ExecutionPrice: item.price || 0,
              ExecutionValueDate: date,
              ExecutionTotal: ExecutionTotal,
              SettlementCurrencyId: order.OrderSettlementCurrencyId,
              TradingRouteId: tradingRouteSelected.TradingRouteId,
            },
          }

          if (order.AssetClassForm === "Repo" && contractdata)
            payload.execution.contractdata = { ...contractdata, closing: closingLeg }

          services
            .getExecutionFees(payload)
            .then(({ response }) => {
              item.Fees = response.execution.Fees
              let orderPrice = 0
              if (order.OrderType === "Limit") orderPrice = order.OrderPrice
              if (order.OrderType === "Stop") orderPrice = order.OrderStopPrice
              setItems((prev) => ({
                ...prev,
                [itemId]: {
                  ...item,
                  loading: false,
                  enabled: !item.enabled,
                  error_price: item.enabled ? undefined : item.error_price,
                  error_quantity: item.enabled ? undefined : item.error_quantity,
                  ExecutionTotal: ExecutionTotal,
                  price: orderPrice,
                },
              }))
              setLoadingItem((prev) => ({ ...prev, [itemId]: false }))
            })
            .catch((err) => {
              console.error(err)
              showToast("Error fetching fees")
            })
        })
        .catch((err) => {
          console.error(err)
          showToast("Error fetching fees")
        })
    })

    if (order.AssetClassForm === "Repo") {
      // es repo, crear contractdata y bloquear la selección del resto de ordenes
      const selectedOrder = orders[itemId]
      const mainOrder = order

      const newContractdata = {
        ContractType: "Repo",
        term: mainOrder.OrderTerm,
        margin: 0,
        RefAssetid: mainOrder.AssetId,
        price: 0,
        rate: mainOrder.OrderType === "Limit" ? +mainOrder.OrderPrice : 0,
        limit: mainOrder.OrderType === "Limit" ? +mainOrder.OrderPrice : 0,
        appraisal: 100,
        marketValue: 0,
        currency: mainOrder.OrderCurrencySymbol,
        open: false,
        opening: 0,
        closing: 0,
        CollateralAssetid: 0,
        CollateralAssetTicker: "",
        CollateralQuantity: 0,
        couponPayments: [],
        paymenttoborrower: paymentToBorrower,
      }

      services
        .fetchGetAssetQuote({
          assetquote_in: {
            assetid:
              mainOrder.OrderSide === "Sell"
                ? mainOrder.CurrentAccount.Collateral[0].AssetId
                : selectedOrder.CurrentAccount.Collateral[0].AssetId,
            Date: date,
            AssetQuotePrice: true,
          },
        })
        .then(({ response }) => {
          let collateral =
            mainOrder.OrderSide === "Sell"
              ? mainOrder.CurrentAccount.Collateral[0]
              : selectedOrder.CurrentAccount.Collateral[0]

          newContractdata.price = response.assetquote_out.AssetQuotePrice
          newContractdata.CollateralAssetid = collateral.AssetId
          newContractdata.CollateralAssetTicker = collateral.AssetTicker
          newContractdata.CollateralQuantity = collateral.CollateralQuantity

          setContractdata(() => newContractdata)
          setAllowSelection(() => false)
        })
        .catch((err) => {
          console.error(err)
          showToast("Error fetching collateral asset price", true)
        })
    }
  }

  const changeItem = (itemId, name, value) => {
    setItems((prevItems) => ({
      ...prevItems,
      [itemId]: {
        ...prevItems[itemId],
        [name]: isNaN(value) || value == "" ? value : +value,
        [`error_${name}`]: undefined,
      },
    }))
  }

  const validate = () => {
    const { crossingAverage } = totals
    let _items = Object.assign({}, debItems)
    let hasItems = false
    let hasErrors = false
    let newError

    if (date === undefined || date === null) {
      newError = "Trade date is a required field"
      hasErrors = true
    }
    if (valueDate === undefined || valueDate === null) {
      newError = "Value date is a required field"
      hasErrors = true
    }

    if (
      (order.OrderType == OrderPriceType.LIMIT || order.OrderType == OrderPriceType.STOPLIMIT) &&
      order.AssetClassForm !== "Repo"
    ) {
      if (order.OrderSide == "Buy" && +order.OrderPrice < +crossingAverage) {
        newError = "Invalid price upper limit"
        hasErrors = true
      }
      if (order.OrderSide == "Sell" && +order.OrderPrice > +crossingAverage) {
        newError = "Invalid price above limit"
        hasErrors = true
      }
    }

    let dateAux = new Date(date)
    dateAux = new Date(`${dateAux.toDateLocal()}T00:00`)
    const valueDateAux = new Date(`${valueDate}T00:00`)
    if (dateAux > valueDateAux) {
      newError = "Value date should be after or at trade date"
      hasErrors = true
    }

    Object.entries(debItems).forEach((entry) => {
      const [name, value] = entry

      if (value.enabled) {
        if (order.AssetClassForm !== "Repo") {
          if (value.quantity === undefined || value.quantity === "" || value.quantity === 0) {
            _items[name].error_quantity = "Required field"
            hasErrors = true
          } else if (order) {
            const orderIsCash = order.OrderQuantityIsCash
            const quantityInCashOrShares = orderIsCash
              ? +value.quantity * +value.price * parValue
              : +value.quantity
            if (quantityInCashOrShares > +order.stats.pending) {
              _items[name].error_quantity = orderIsCash
                ? "Quantity * Price is over order"
                : "Quantity is over order"
              hasErrors = true
            }
          }

          if (value.price === undefined || value.price === "") {
            _items[name].error_price = "Required field"
            hasErrors = true
          }

          if (
            order &&
            (order.OrderType == OrderPriceType.LIMIT || order.OrderType == OrderPriceType.STOPLIMIT)
          ) {
            if (order.OrderSide == "Buy" && +order.OrderPrice < +value.price) {
              _items[name].error_price = "Invalid price upper limit"
              hasErrors = true
            }
            if (order.OrderSide == "Sell" && +order.OrderPrice > +value.price) {
              _items[name].error_price = "Invalid price above limit"
              hasErrors = true
            }
          }

          const selectedOrder = Object.values(orders).filter((order) => order.OrderId === name)
          if (order && selectedOrder.length > 0) {
            if (selectedOrder[0].OrderType === OrderPriceType.LIMIT) {
              if (
                order.OrderSide === "Buy" &&
                parseFloat(items[selectedOrder[0].OrderId].price) < parseFloat(selectedOrder[0].OrderPrice)
              ) {
                _items[name].error_price = "Price above limit"
                hasErrors = true
              } else if (
                order.OrderSide === "Sell" &&
                parseFloat(items[selectedOrder[0].OrderId].price) > parseFloat(selectedOrder[0].OrderPrice)
              ) {
                _items[name].error_price = "Price upper limit"
                hasErrors = true
              }
            }
          }
        }

        hasItems = true
      }
    })

    if (_items["a1"].enabled && _items["a1"].account == undefined) {
      _items["a1"].error_account = "Required field"
      hasErrors = true
    }

    if (!hasItems) {
      newError = "Empty crossing"
      hasErrors = true
    } else if (totals.buySide < 0 || totals.sellSide < 0) {
      newError = "Total execution quantity is over order quanttiy"
      hasErrors = true
    }

    setItems(() => _items)
    setError(() => newError)

    if (order.AssetClassForm === "Repo") {
      const newErrors = {}

      if (+order.OrderPrice > 0 && +order.OrderPrice < +contractdata.rate) {
        newErrors["CollateralRate"] = "Invalid rate above limit"
        hasErrors = true
      }

      if (+contractdata.CollateralQuantity === 0) {
        newErrors["CollateralQuantity"] = "Invalid quantity cannot be 0"
        hasErrors = true
      }

      if (+contractdata.appraisal > 100 || +contractdata.appraisal < 0) {
        newErrors["CollateralAppraisal"] = "Invalid appraisal outside limits"
        hasErrors = true
      }

      if (+contractdata.margin > 100 || +contractdata.margin < 0) {
        newErrors["CollateralHaircut"] = "Invalid haircut outside limits"
        hasErrors = true
      }

      if (+contractdata.appraisal + +contractdata.margin !== 100) {
        newErrors["CollateralAppraisal"] = "Invalid haircut/appraisal balance"
        newErrors["CollateralHaircut"] = "Invalid haircut/appraisal balance"
        hasErrors = true
      }

      if (contractdata.maturity === undefined || contractdata.maturity === null) {
        newErrors["CollateralMaturity"] = "Required field"
        hasErrors = true
      }

      setErrors(() => newErrors)
    }

    return !hasErrors
  }

  const onCross = () => {
    setConfirm(() => ({ loading: true }))
    if (validate()) {
      const { fetchAddExecutions } = services

      let executions = []
      let propExecution = { ExecutionId: 0 }
      const newTotals = calcTotals(debItems)
      services
        .fetchGetCalculator({
          assetId: order.AssetId,
          isSecurity: true,
          quantity: newTotals.crossingQuantity || 1,
          price: newTotals.crossingAverage || 1,
          // setTotals(() => newTotals);
          // setError(() => undefined);
          // ahora por cada uno
          date: date,
        })
        .then((res2) => {
          const ExecutionTotal2 = res2.calculator.total
          const payload = {
            crossType: "",
            execution: {
              ExecutionQuantity: newTotals.crossingQuantity || 0,
              ExecutionPrice: newTotals.crossingAverage || 0,
              ExecutionValueDate: date,
              ExecutionTotal: ExecutionTotal2,
              SettlementCurrencyId: order.OrderSettlementCurrencyId,
              TradingRouteId: tradingRouteSelected.TradingRouteId,
              ExecutionTrader: selectedTrader,
            },
          }

          if (order.AssetClassForm === "Repo" && contractdata) {
            payload.execution.contractdata = { ...contractdata, closing: closingLeg }
          }

          services
            .getExecutionFees(payload)
            .then(({ response }) => {
              newTotals.Fees = response.execution.Fees
              newTotals.ExecutionTotal = ExecutionTotal2

              const promises = Object.entries(debItems).map((entry) => {
                const [name, value] = entry

                return services
                  .fetchGetCalculator({
                    assetId: order.AssetId,
                    isSecurity: true,
                    quantity: value.quantity || 1,
                    price: value.price || 1,
                    date: date,
                  })
                  .then((res) => {
                    const ExecutionTotal = res.calculator.total
                    const payload2 = {
                      crossType: "",
                      execution: {
                        ExecutionQuantity: value.quantity || 0,
                        ExecutionPrice: value.price || 0,
                        ExecutionValueDate: date,
                        ExecutionTotal: ExecutionTotal,
                        SettlementCurrencyId: order.OrderSettlementCurrencyId,
                        TradingRouteId: tradingRouteSelected.TradingRouteId,
                        ExecutionTrader: selectedTrader,
                      },
                    }

                    if (order.AssetClassForm === "Repo" && contractdata) {
                      payload2.execution.contractdata = { ...contractdata, closing: closingLeg }
                    }

                    return services
                      .getExecutionFees(payload2)
                      .then(({ response }) => {
                        value.Fees = response.execution.Fees
                        value.ExecutionTotal = ExecutionTotal
                        return { name, value }
                      })
                      .catch((err) => {
                        console.error(err)
                        showToast("Error fetching fees")
                      })
                  })
                  .catch((err) => {
                    console.error(err)
                    showToast("Error fetching fees")
                  })
              })

              const newItems = {}
              Promise.all(promises).then((itemFee) => {
                newItems[itemFee[0].name] = {
                  Fees: itemFee[0].value.Fees,
                  ExecutionTotal: itemFee[0].value.ExecutionTotal,
                }

                const fixedItems = {}
                Object.entries(debItems).forEach((entry) => {
                  let [name, value] = entry
                  value = { ...value, ...newItems[name] }
                  fixedItems[name] = value
                })
                //aca estaria todo
                Object.entries(fixedItems).forEach((entry) => {
                  let [name, value] = entry

                  if (value.enabled) {
                    if (name != "a1") {
                      const auxExecution = {
                        ExecutionId: name,
                        ExecutionQuantity: value.quantity,
                        ExecutionPrice: value.price,
                        ExecutionTotal: value.ExecutionTotal,
                        Fees: value.Fees || [],
                        ExecutionTrader: selectedTrader,
                      }

                      if (order.AssetClassForm === "Repo") {
                        auxExecution.contractdata = {
                          ...contractdata,
                          closing: closingLeg,
                          contractCounterParty: order.CurrentAccount.AccountId,
                        }
                        auxExecution.ExecutionQuantity = 1
                        auxExecution.ExecutionPrice = 1
                        auxExecution.ExecutionTotal = 1
                      }
                      executions.push(auxExecution)
                    }
                  }
                })

                const executionToAdd = {
                  ExecutionId: order.OrderId,
                  ExecutionQuantity: totals.crossingQuantity,
                  ExecutionPrice: totals.crossingAverage,
                  ExecutionTotal: totals.ExecutionTotal,
                  Fees: totals.Fees || [],
                  ExecutionTrader: selectedTrader,
                }

                if (order.AssetClassForm === "Repo") {
                  executionToAdd.contractdata = contractdata
                  executionToAdd.contractdata.closing = closingLeg
                  executionToAdd.ExecutionQuantity = 1
                  executionToAdd.ExecutionPrice = 1
                }

                executions.push(executionToAdd)

                if (fixedItems["a1"].enabled) {
                  propExecution = {
                    ExecutionId: fixedItems["a1"].account,
                    ExecutionQuantity: fixedItems["a1"].quantity,
                    ExecutionPrice: fixedItems["a1"].price,
                    ExecutionTotal: fixedItems["a1"].ExecutionTotal,
                    Fees: fixedItems["a1"].Fees || [],
                    ExecutionTrader: selectedTrader,
                  }
                }

                let fxMultiplies = true
                const settleCurrencyInfo = settlementCurrencies.find(
                  (c) => c.currencyInfo.currencyId == order.OrderSettlementCurrencyId
                )

                if (settleCurrencyInfo) {
                  fxMultiplies = settleCurrencyInfo.multiplies
                }

                fetchAddExecutions({
                  executions,
                  propExecution,
                  refOrderId: order.OrderId,
                  crossType: String(tradingRouteSelected.TradingRouteId),
                  dateTime: localDateToGMT(date),
                  valueDate,
                  fx,
                  fxMultiplies,
                }).then((res) => {
                  const { result } = res.response
                  if (result.Code == 200) {
                    onToggle()
                  } else {
                    alert(result.Description)
                    setConfirm(() => ({ loading: false }))
                  }
                })
              })
            })
            .catch((err) => {
              console.error(err)
              showToast("Error fetching fees")
            })
        })
        .catch((err) => {
          console.error(err)
          showToast("Error fetching fees")
        })
    } else {
      setConfirm(() => ({ loading: false }))
    }
  }

  const calcTotals = (items) => {
    const isBuy = order.OrderSide == "Buy"
    const isCash = order.OrderQuantityIsCash
    const isRepo = order.AssetClassForm == "Repo"

    let totals = {
      crossingQuantity: null,
      crossingAverage: null,
      buySide: null,
      sellSide: null,
    }

    let totalQtyPendingOrders = 0,
      totalQtyCross = 0,
      totalQtyMultPrice = 0

    Object.entries(items).forEach((entry) => {
      const [name, value] = entry

      if (value.enabled && !isNaN(value.quantity) && !isNaN(value.price)) {
        if (name != "a1") {
          const order2 = orders[name]
          const order2PendingQty =
            +order2.stats.pending -
            (order2.OrderQuantityIsCash ? +value.quantity * +value.price * parValue : +value.quantity)
          totalQtyPendingOrders += order2PendingQty
        }
        totalQtyCross += +value.quantity
        totalQtyMultPrice += +value.quantity * +value.price
      }
    })

    const sideOrder = isBuy ? "buySide" : "sellSide"
    const sideCross = sideOrder == "buySide" ? "sellSide" : "buySide"

    totals[sideOrder] = isRepo
      ? 1
      : +order.stats.pending - (isCash ? totalQtyMultPrice * parValue : totalQtyCross)

    if (totalQtyCross > 0) {
      totals[sideCross] = isRepo ? 1 : totalQtyPendingOrders
      totals.crossingQuantity = totalQtyCross
      totals.crossingAverage = totalQtyCross ? (totalQtyMultPrice / totalQtyCross).toFixed(8) : null
    }

    return totals
  }

  const handleChangeContractData = (name, value) => {
    setContractdata((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleChangeClosingLeg = (value) => {
    setClosingLeg(() => value)
  }

  const handleGetLegs = () => {
    if (contractdata) {
      setCalculatingLegs(() => true)
      services
        .fetchGetOpeningAndClosingLegs({
          execution: {
            ExecutionValueDate: valueDate,
            TradingRouteId: tradingRouteSelected.TradingRouteId,
            contractdata: { ...contractdata, closing: closingLeg },
          },
        })
        .then(({ response }) => {
          const newLegs = {
            opening: response.openingleg,
            marketValue: response.marketvalue,
            couponPayments: response.cashflow_outs.map((payment) => ({
              ContractPaymentDate: payment.date,
              ContractPaymentName: payment.name,
              ContractPaymentAmmount: payment.payment,
              ContractPaymentAdjustedAmmount: payment.adjusted,
            })),
          }

          setClosingLeg(() => response.closingleg)

          setContractdata((prev) => ({
            ...prev,
            ...newLegs,
          }))
        })
        .catch((err) => {
          console.error(err)
          showToast("Error fetching opening and closing legs", true)
        })
        .finally(() => {
          setCalculatingLegs(() => false)
          setFirst(() => false)
        })
    }
  }

  const handleChangeAppraisal = (event) => {
    const value = event.value
    setContractdata((prev) => ({
      ...prev,
      appraisal: value,
      margin: 100 - +value,
    }))
  }

  const handleChangeHaircut = (event) => {
    const value = event.value
    setContractdata((prev) => ({
      ...prev,
      margin: value,
      appraisal: 100 - +value,
    }))
  }

  const handleChangeTradingRoute = (id) => {
    setTradingRouteSelected({ TradingRouteId: id })
  }

  const toggleShowFees = () => {
    setShowFees((prev) => !prev)
  }

  const handleChangeType = (v) => {
    setType(() => v)
    if (order.AssetClassForm == "Repo" && contractdata) {
      let isInternal = v == "Internal"
      setContractdata({ ...contractdata, paymenttoborrower: isInternal })
    }
  }

  const handleChangeDate = (v) => {
    setDate(v)
  }

  const handleChangeValueDate = (v) => {
    setValueDate(v)
  }

  return (
    <Modal isOpen={open} toggle={onToggle} className={style.modal}>
      <ModalHeader toggle={onToggle}>
        Order Cross
        <OrderInlineDetail order={order} />
      </ModalHeader>
      <ModalBody style={{ padding: "10px 15px", minHeight: "225px" }}>
        <Row>
          {!isFX && hasDifferentCurrencies && (
            <React.Fragment>
              <Col lg={3}>
                <Field>
                  <Switch value={manualFX} label={"Manual"} onChange={(v) => setManualFX(v)} />
                </Field>
              </Col>
              <Col lg={3}>
                <Field label={`FX ${baseCurrency}/${priceCurrency}`} error={error}>
                  <NumberFormatInput
                    type='text'
                    customInput={Input}
                    value={fx || ""}
                    invalid={!!error}
                    onValueChange={(e) => setFx(() => e.value)}
                    dataTypeDecimalName='currency'
                    placeholder={"FX"}
                    disabled={!manualFX}
                  />
                </Field>
              </Col>
            </React.Fragment>
          )}
        </Row>

        {allowSelection && (
          <React.Fragment>
            <Line mb={"8px"} />
            {filterOrders(orders).map((o, index) => (
              <ItemRow
                order={o}
                id={o.OrderId}
                item={items[o.OrderId]}
                fees={itemsFees[o.OrderId]}
                maxDecimals={maxDecimals}
                key={`irow-${index}`}
                loading={loadingItem[o.OrderId]}
                actions={{
                  toggle: toggleItem,
                  change: changeItem,
                }}
              />
            ))}

            {order.AssetClassForm !== "Repo" && (
              <ItemRow
                id={"a1"}
                item={items["a1"]}
                maxDecimals={maxDecimals}
                loading={loadingItem["a1"]}
                fees={itemsFees["a1"]}
                actions={{
                  toggle: toggleItem,
                  change: changeItem,
                }}
              >
                <AccountsField
                  id={"a1"}
                  accounts={accounts}
                  onChange={changeItem}
                  item={items["a1"]}
                  items={items}
                />
              </ItemRow>
            )}
          </React.Fragment>
        )}

        {filterOrders(orders).length == 0 && (
          <h5 style={{ margin: "80px 230px", textAlign: "center" }}>No orders for crossing</h5>
        )}

        {order.AssetClassForm == "Repo" && contractdata && (
          <RepoCross
            errors={errors}
            contractdata={contractdata}
            calculatingLegs={calculatingLegs}
            handleChangeContractData={handleChangeContractData}
            handleChangeAppraisal={handleChangeAppraisal}
            handleChangeHaircut={handleChangeHaircut}
            closingLeg={closingLeg}
            handleChangeClosingLeg={handleChangeClosingLeg}
            maxDecimals={maxDecimals}
          />
        )}

        <DateAndCrossingType
          date={date}
          valueDate={valueDate}
          type={type}
          onChangeType={handleChangeType}
          onChangeDate={handleChangeDate}
          onChangeValueDate={handleChangeValueDate}
          onHandleSelectedTrader={handleSelectedTrader}
          tradingRoutes={tradingRoutes}
          onChangeTradingRoute={handleChangeTradingRoute}
          tradingRouteSelected={tradingRouteSelected}
          tradersNames={tradersNames}
          showTraderName={showTraderName}
        />
        {totals.Fees && (
          <React.Fragment>
            <span className={style.showOwnFeesLink} onClick={toggleShowFees}>
              Show fees
            </span>
            {showFees && <Fees fees={totals.Fees} />}
          </React.Fragment>
        )}
        {error && (
          <Fragment>
            <hr />
            <Alert color='danger' className={style.alert}>
              {error}
            </Alert>
          </Fragment>
        )}
      </ModalBody>

      <ModalFooter style={{ padding: "12px 20px" }}>
        <FooterTotals totals={totals} />

        <Button color='light' onClick={onToggle}>
          Close
        </Button>
        {accountsSelected && (
          <LaddaButton
            className={classnames("btn btn-ladda", order.OrderSide == "Buy" ? style.buy : style.sell)}
            loading={confirm.loading}
            onClick={onCross}
            data-style={EXPAND_RIGHT}
            disabled={confirm.loading}
          >
            Cross
          </LaddaButton>
        )}
      </ModalFooter>
    </Modal>
  )
}

const RepoCross = ({
  errors,
  contractdata,
  calculatingLegs,
  handleChangeContractData,
  handleChangeAppraisal,
  handleChangeHaircut,
  closingLeg,
  handleChangeClosingLeg,
  maxDecimals,
}) => {
  // cross trade for repo, contract info
  return (
    <Row>
      <Col>
        <Row>
          <Col>Contract Details</Col>
        </Row>
        <div className={style.contractDetailsWrapper}>
          <Row>
            <Col>
              <Field label='Asset'>
                <Input
                  type='text'
                  placeholder='Asset'
                  disabled
                  value={contractdata.CollateralAssetTicker}
                  onChange={(e) => {}}
                />
              </Field>
            </Col>
            <Col>
              <Row>
                <Col>
                  <Field label='Quantity' error={errors["CollateralQuantity"]}>
                    <NumberFormatInput
                      type='text'
                      customInput={Input}
                      value={contractdata.CollateralQuantity}
                      onValueChange={(e) => {
                        handleChangeContractData("CollateralQuantity", e.value)
                      }}
                      dataTypeDecimalName='quantity'
                      placeholder='Quantity'
                    />
                  </Field>
                </Col>
                @
                <Col>
                  <Field label='Price'>
                    <NumberFormatInput
                      type='text'
                      customInput={Input}
                      value={contractdata.price}
                      onValueChange={(e) => {
                        handleChangeContractData("price", e.value)
                      }}
                      decimalScale={maxDecimals}
                      dataTypeDecimalName='price'
                      placeholder='Price'
                    />
                  </Field>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col>
              <Row>
                <Col>
                  <Field label='Appraisal' error={errors["CollateralAppraisal"]}>
                    <NumberFormatInput
                      type='text'
                      customInput={Input}
                      value={contractdata.appraisal}
                      onValueChange={handleChangeAppraisal}
                      dataTypeDecimalName='percentage'
                      allowNegative={false}
                      placeholder='Appraisal'
                      suffix='%'
                    />
                  </Field>
                </Col>
                <Col>
                  <Field label='Haircut' error={errors["CollateralHaircut"]}>
                    <NumberFormatInput
                      type='text'
                      customInput={Input}
                      value={contractdata.margin}
                      onValueChange={handleChangeHaircut}
                      dataTypeDecimalName='percentage'
                      allowNegative={false}
                      placeholder='Haircut'
                      suffix='%'
                    />
                  </Field>
                </Col>
              </Row>
            </Col>
            <Col>
              <Row>
                <Col>
                  <Field label='Market Value'>
                    <NumberFormatInput
                      type='text'
                      customInput={Input}
                      value={contractdata.marketValue}
                      onValueChange={(e) => {
                        handleChangeContractData("marketValue", e.value)
                      }}
                      dataTypeDecimalName='quantity'
                      disabled
                      placeholder='Quantity'
                    />
                  </Field>
                </Col>

                <Col>
                  <Field label='Currency'>
                    <Input
                      type='text'
                      customInput={Input}
                      value={contractdata.currency}
                      dataTypeDecimalName='currency'
                      disabled
                      placeholder='Currency'
                    />
                  </Field>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col>
              <Field label='Maturity' error={errors["CollateralMaturity"]}>
                <Input
                  type='date'
                  placeholder={"Maturity"}
                  step='1'
                  value={contractdata.maturity}
                  onChange={(e) => handleChangeContractData("maturity", e.target.value)}
                />
              </Field>
            </Col>
            <Col>
              <Row>
                <Col>
                  <Field label='Rate' error={errors["CollateralRate"]}>
                    <NumberFormatInput
                      type='text'
                      customInput={Input}
                      value={contractdata.rate}
                      onValueChange={(e) => {
                        handleChangeContractData("rate", e.value)
                      }}
                      dataTypeDecimalName='percentage'
                      placeholder='Rate'
                      suffix='%'
                    />
                  </Field>
                  <CustomInput
                    type='checkbox'
                    id='check-paymentToBorrower'
                    name='check-paymentToBorrower'
                    label='Payments go to repo borrower'
                    // className="pl-1 mt-1"
                    checked={contractdata.paymenttoborrower}
                    onChange={() =>
                      handleChangeContractData("paymenttoborrower", !contractdata.paymenttoborrower)
                    }
                  />
                </Col>
                <Col>
                  <div className={style.leg}>
                    <span className={style.opening}>Opening leg</span> {contractdata.currency}{" "}
                    {calculatingLegs ? (
                      <CircularProgress sm />
                    ) : (
                      <NumberFormatInput
                        type='text'
                        customInput={Input}
                        value={contractdata.opening}
                        dataTypeDecimalName='currency'
                        placeholder='Opening Leg'
                        disabled
                      />
                    )}
                  </div>
                  <div className={style.leg}>
                    <span className={style.closing}>Closing leg</span> {contractdata.currency}{" "}
                    {calculatingLegs ? (
                      <CircularProgress sm />
                    ) : (
                      <NumberFormatInput
                        type='text'
                        customInput={Input}
                        value={closingLeg}
                        onValueChange={(e) => {
                          handleChangeClosingLeg(e.value)
                        }}
                        dataTypeDecimalName='currency'
                        placeholder='Closing Leg'
                      />
                    )}
                  </div>
                  <CouponPayments payments={contractdata.couponPayments} />
                </Col>
              </Row>
            </Col>
          </Row>
          {/* <Row>
            <Col>
              <Label check>
                <Input
                  className={style.openCheckbox}
                  value={contractdata.open}
                  checked={contractdata.open}
                  onClick={(e) => {
                    handleChangeContractData("open", e.target.checked);
                  }}
                  type="checkbox"
                />
                Open
              </Label>
            </Col>
          </Row> */}
        </div>
      </Col>
    </Row>
  )
}

const DateAndCrossingType = ({
  type,
  date,
  valueDate,
  error,
  tradersNames,
  execution,
  enabled,
  onChangeType,
  onChangeDate,
  onChangeValueDate,
  tradingRoutes,
  onChangeTradingRoute,
  tradingRouteSelected,
  onHandleSelectedTrader,
  selectedTrader,
  showTraderName,
}) => (
  <div className={style.crossingType}>
    <div className={style.gridContainer}>
      <div>
        <TradingRoutes
          value={tradingRouteSelected.TradingRouteId}
          onChange={onChangeTradingRoute}
          tradeRoutes={tradingRoutes && tradingRoutes.length > 0 ? tradingRoutes : null}
        />
      </div>

      {/* <Field label={"Cross type"}> */}
      {/* <Combobox
        value={type}
        enabled={enabled}
        items={[
          { id: "Internal", description: "Internal" },
          { id: "Custody", description: "Bolsa" },
        ]}
        onChange={onChangeType}
        emptyLabel={"Cross type"}
        invalid={!!error}
        style={{ minWidth: "165px", marginRight: "30px" }}
      />
    </Field> */}
      <Field label={"Date time"}>
        <Input
          type='datetime-local'
          step='1'
          placeholder={"Date time"}
          enabled={enabled}
          value={date}
          invalid={!!error}
          onChange={(e) => onChangeDate(e.target.value)}
          style={{ width: "100%" }}
        />
      </Field>
      <Field label={"Settlement Date (value date)"}>
        <Input
          type='date'
          placeholder={"Settlement Date"}
          readOnly={enabled}
          value={valueDate || ""}
          invalid={!!error}
          onChange={(e) => onChangeValueDate(e.target.value)}
          style={{ width: "100%" }}
        />
      </Field>
      <div>
        {showTraderName && (
          <Field label={"Trader Name"}>
            <Input
              type='select'
              value={selectedTrader}
              onChange={(e) => onHandleSelectedTrader(e.target.value)}
            >
              <option value=''></option>
              {tradersNames &&
                tradersNames.map((option, index) => (
                  <option key={index} value={option.value}>
                    {option.value}
                  </option>
                ))}
            </Input>
          </Field>
        )}
      </div>
    </div>
  </div>
)

const Number = ({ value, dataTypeDecimalName }) => {
  if (value === null) {
    return "-"
  }
  return <FormattedNumber value={value} dataTypeDecimalName={dataTypeDecimalName} />
}

const AccountsField = ({ accounts, id, onChange, item, items }) => {
  if (!item) return <CircularProgress sm style={{ margin: "30px 0 0 25px" }} />
  const error_account = item.error_account || ""

  return accounts == null || !item ? (
    <CircularProgress sm style={{ margin: "30px 0 0 25px" }} />
  ) : (
    <Field label='Account' error={error_account}>
      <Combobox
        value={item.account}
        disabled={!item.enabled}
        items={accounts}
        invalid={!!error_account}
        onChange={(v) => onChange(id, "account", v)}
        emptyLabel='Account'
      />
    </Field>
  )
}

const Line = ({ mb = "4px" }) => (
  <hr
    style={{
      margin: `4px 0px ${mb} 0px`,
      borderTop: "solid 1px lightgray",
    }}
  />
)

const FooterTotals = ({ totals }) => (
  <div className={style.footerTotals}>
    <div style={{ marginRight: "40px", minWidth: "240px" }}>
      <table style={{ margin: "10px 0px" }}>
        <tbody>
          <tr>
            <td>Crossing quantity</td>
            <td>
              <Number value={totals.crossingQuantity} dataTypeDecimalName='quantity' />
            </td>
          </tr>
          <tr>
            <td>Average</td>
            <td>
              <Number value={totals.crossingAverage} dataTypeDecimalName='price' />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div>
      <strong>Leftovers</strong>
      <table>
        <tbody>
          <tr>
            <td style={{ color: "#4dbd74", fontWeight: 500 }}>Buy side</td>
            <td>
              <Number value={totals.buySide} dataTypeDecimalName='currency' />
            </td>
          </tr>
          <tr>
            <td style={{ color: "#f86c6b", fontWeight: 500 }}>Sell side</td>
            <td>
              <Number value={totals.sellSide} dataTypeDecimalName='currency' />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
)

const filterOrders = (orders) => Object.values(orders).filter((o) => true)

const Fees = ({ fees }) => {
  return (
    <div className={style.feesContainer}>
      <Table className={style.feesTable} responsive>
        <tbody>
          {fees.map((feeItem, idx) => (
            <tr key={idx}>
              <td>
                {feeItem.Description}:{" "}
                <FormattedNumber value={feeItem.FeeAmount} dataTypeDecimalName='currency' />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  )
}

export default Cross
